/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { livenessLiveness } from "../funcs/livenessLiveness.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import * as components from "../models/components/index.js";
import { unwrapAsync } from "../types/fp.js";

export class Liveness extends ClientSDK {
  /**
   * Health check
   *
   * @remarks
   * Check if the Teral API service is healthy and ready to handle requests.
   *
   * Use this for load balancer health checks, monitoring systems, and orchestration platforms. No authentication required with minimal processing overhead.
   *
   * **Required Permissions**
   *
   * None - this endpoint requires no authentication.
   *
   * **Side Effects**
   *
   * None - this is a read-only health check that does not modify any data or state.
   */
  async liveness(
    options?: RequestOptions,
  ): Promise<components.V1LivenessResponseBody> {
    return unwrapAsync(livenessLiveness(
      this,
      options,
    ));
  }
}
